import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { PartecipataEnteDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class PartecipataEnteApiClient extends BaseCRUDApiClient<PartecipataEnteDto> {
  baseUrl = this.config.apiEndpoint + '/partecipata-ente';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  duplicatePartecipateEnte() {
    this._pagedCache.clear();
    return this.http.get(`${this.baseUrl}/duplicate-partecipate-ente/`);
  }
}
